import React from 'react';
import { useSelector } from 'react-redux';
import UnsubscribeAllView from './UnsubscribeAllView';

import type { State } from 'app/shared/types/State';

const UnsubscribeAllPage = () => {
  const didUnsubscribeAllSucceed = useSelector((state: State) => state.marketing.didUnsubscribeAllSucceed);

  return <UnsubscribeAllView didUnsubscribeAllSucceed={didUnsubscribeAllSucceed} />;
};

export default UnsubscribeAllPage;
